import React, {useState, useEffect, useRef} from 'react';
import { Button, Card,CardText, ListGroup, ListGroupItem, Form} from 'react-bootstrap';
import Auth from '../utils/auth';
import HeroBackground from '../HeroBackground';
import ImageCropModal from '../ImageCropModal';

function SignUp() {

  const [crewmember, setCrewmember] = useState(null); 
  const [error, setError] = useState(null);
  const [selectedPosition, setSelectedPosition] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');
  const [selectedUnionType, setSelectedUnionType] = useState('');
  const [selectedUnion, setSelectedUnion] = useState('');
  const [selectedLocal, setSelectedLocal] = useState('');
  const [profilePreviews, setProfilePreviews] = useState([]);
  const [isResumeDeleted, setIsResumeDeleted] = useState(false);
  const [residencePreview, setResidencePreview] = useState(null);
  const [isResidenceDeleted, setIsResidenceDeleted] = useState(false);

  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [locationError, setLocationError] = useState("");
  const [positionError, setPositionError] = useState("");
  const [departmentError, setDepartmentError] = useState("");
  const [unionError, setUnionError] = useState(null);
   const [localError, setLocalError] = useState(null);
  const [unionTypeError, setUnionTypeError] = useState("");
  const [workRegionError, setWorkRegionError] = useState("");
  const [profileIError, setProfileIError] = useState("");
  const [residenceError, setResidenceError] = useState("");
  const [isTyping, setIsTyping] = useState(false);

  const [formState, setFormState] = useState({ 
    email: '', 
    password: '', 
    crewmember: '',
    union: '',
    location: '',
    local: '',
    bio:'',
    iMDB: '',
    workRegion: [], 
    unionType: [],
    resumes: [{ title: '', year: '', position: '' }],
    resumeP: null,
    residence: null,
    position: [],
    department: [],
    profileI: [],  
   });

   const workRegion = ['Central', 'East', 'Dallas Fort Worth', 'Gulf Coast', 'Panhandle', 'West'];
   const positions = [
    'actor', 'producer', 'executive producer', 'co-executive producer',
    'showrunner', 'unit production manager', 'production coordinator', 'director', 
    'assistant director', '1st assistant director', '2nd assistant director', 
    'camera operator',  'key hair', 'key makeup', 'production accountant',
    '1st assistant accountant', 'writer', 'sound mixer', 'boom operator', 
    'location manager', 'assistant location manager', 'key grip', 'best boy grip', 
    'gaffer', 'best boy electric', 'transportation coordinator', 'picture car coordinator',
    'key set costumer', 'buyer', 'set decorator', 'lead man', 'production designer', 'art director',
    'music supervisor', 'composer', 'spfx coordinator', 'spfx buyer', 'editor', 'assistant editor',
  ];

  const departments = [
    'Production', 'Accounting', 'Talent', 'Writer', 'Camera', 'Sound', 'Construction', 'Art Department', 'Set Dec',
    'Grip', 'Electric', 'Stunts', 'Costumes', 'Hair and Makeup', 'Craft Services', 'Medic', 'Locations', 'Transportation', 'Music', 'Post Production', 'SPFX',
  ]

  const unionType = [
    'DGA', 
    'IATSE 484', 
    'IATSE 600', 
    'TEAMSTERS LOCAL 657', 
    'IATSE 700', 
    'IATSE 797', 
    'LMGI', 
    'PGA',
    'Association of Independent Commercial Producers', 
    'AFS Producer', 
    'SAG AFTRA', 
    'SAG Eligible', 
    'WGA West', 
    'WGA East', 
    'The American Society of Composers, Authors, and Publishers',
    'International Game Developers Association',
    'VES',
    'BMI',
    'None',
  ]

  const texasCities = [
    'Abilene', 'Alice', 'Alpine', 'Amarillo', 'Arlington', 'Austin', 'Atascocita',
    'Baytown', 'Bastrop', 'Beaumont', 'Boerne', 'Brownsville', 'Bryan', 'Burnet',
    'Carrollton', 'Cedar Park', 'College Station', 'Conroe', 'Corpus Christi',
    'Cuero', 'Dallas', 'Del Rio', 'Denton', 'Eagle Pass', 'Edinburg', 'El Paso',
    'Flower Mound', 'Fort Worth', 'Fredericksburg', 'Frisco', 'Georgetown',
    'Gonzales', 'Grand Prairie', 'Grapevine', 'Harlingen', 'Houston', 'Huntsville',
    'Irving', 'Junction', 'Kerrville', 'Killeen', 'Kingsville', 'Kyle', 'Leander',
    'Lewisville', 'Longview', 'Lubbock', 'Lufkin', 'McKinney', 'Mansfield',
    'Marble Falls', 'Mesquite', 'Midland', 'Mission', 'Nacogdoches',
    'New Braunfels', 'North Richland Hills', 'Odessa', 'Pampa', 'Pasadena',
    'Pecos', 'Pharr', 'Plainview', 'Plano', 'Rockport', 'Round Rock',
    'San Angelo', 'San Antonio', 'San Marcos', 'Stephenville', 'Temple',
    'Tyler', 'Uvalde', 'Victoria', 'Waco', 'Waxahachie', 'Wichita Falls',
    'Yoakum', 'N/A'
  ].sort();
  

const [cropModalOpen, setCropModalOpen] = useState(false);
const [rawImageSrc, setRawImageSrc] = useState(null);

const handleFileSelect = (event) => {
  const file = event.target.files[0];
  if (file) {
    setRawImageSrc(URL.createObjectURL(file));
    setCropModalOpen(true);
  }
};

const handleCropComplete = (croppedBlob) => {
  setFormState((prevState) => {
    const updatedProfileI = [...prevState.profileI, croppedBlob].slice(0, 3);
    return { ...prevState, profileI: updatedProfileI };
  });

  setProfilePreviews((prevPreviews = []) => {
    const newPreview = URL.createObjectURL(croppedBlob);
    return [...prevPreviews, newPreview].slice(0, 3);
  });

  setCropModalOpen(false);
};

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormState(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };
  
const handleFormSubmit = async (event) => {
    event.preventDefault();

    let hasError = false;

    if (!formState.crewmember.trim()) {
      setNameError('Name required');
        hasError = true;
    } else {
      setNameError(null);
    }
  
    if (!formState.email.trim()) {
      setEmailError('Email required');
        hasError = true;
    } else {
      setEmailError(null);
    }

    if (!formState.password.trim()) {
      setPasswordError('Password required');
        hasError = true;
    } else {
      setPasswordError(null);
    }

    if (!formState.location.trim()) {
      setLocationError('Location required');
        hasError = true;
    } else {
      setLocationError(null);
    }

    if (!formState.position || formState.position.length === 0) {
      setPositionError('Position required');
        hasError = true;
    } else {
      setPositionError(null);
    }

    if (!formState.department || formState.department.length === 0) {
      setDepartmentError('Department required');
        hasError = true;
    } else {
      setDepartmentError(null);
    }

  

    if (!formState.unionType || formState.unionType.length === 0) {
      setUnionTypeError('Union/ Affiliation field required');
        hasError = true;
    } else {
      setUnionTypeError(null);
    }

    if (!formState.workRegion || formState.workRegion.length === 0) {
      setWorkRegionError('Work Region required');
        hasError = true;
    } else {
      setWorkRegionError(null);
    }

    if (!formState.local || formState.local.length === 0) {
      setLocalError('Please Select Yes or No');
        hasError = true;
    } else {
      setLocalError(null);
    }

    if (!formState.profileI || formState.profileI.length === 0) {
      setProfileIError('Profile Picture Required');
        hasError = true;
    } else {
      setProfileIError(null);
    }

    if (!formState.residence || formState.residence.length === 0) {
      setResidenceError('Please Upload Proof of Residency');
        hasError = true;
    } else {
      setResidenceError(null);
    }

    if (hasError) return;


    const formData = new FormData();
  
    formData.append('resumeP', formState.resumeP);
    formData.append('residence', formState.residence);
    formData.append('email', formState.email);
    formData.append('password', formState.password);
    formData.append('crewmember', formState.crewmember);
    formData.append('union', formState.union);
    formData.append('location', formState.location);
    formData.append('local', formState.local);
    formData.append('bio', formState.bio);
    formData.append('iMDB', formState.iMDB);
  
    if (Array.isArray(formState.workRegion)) {
      formState.workRegion.forEach(region => formData.append('workRegion', region));
    } else {
      formData.append('workRegion', formState.workRegion);
    }

    if (Array.isArray(formState.unionType)) {
      formState.unionType.forEach(type => formData.append('unionType', type));
    } else {
      formData.append('unionType', formState.unionType);
    }
  
    if (Array.isArray(formState.position)) {
      formState.position.forEach(pos => formData.append('position', pos));
    } else {
      formData.append('position', formState.position);
    }

    if (Array.isArray(formState.department)) {
      formState.department.forEach(pos => formData.append('department', pos));
    } else {
      formData.append('department', formState.department);
    }
  
    if (Array.isArray(formState.resumes)) {
      formState.resumes.forEach((resume, index) => {
        formData.append(`resumes[${index}].title`, resume.title);
        formData.append(`resumes[${index}].year`, resume.year);
        formData.append(`resumes[${index}].position`, resume.position);
      });
    }

    if (Array.isArray(formState.profileI)) {
      formState.profileI.forEach((file, index) => {
        formData.append(`profileI[${index}]`, file);
      });
    }
  
    try {
      const response = await fetch('https://second-team-productions.onrender.com/crew/signup', {
        method: 'POST',
        body: formData,
      });
  
      if (!response.ok) {
        throw new Error('Failed to register user');
      }
  
      const { token } = await response.json();
      Auth.login(token);
  
    } catch (e) {
      console.error(e);
      
    }
  };
  const handlePositionChange = (e) => {
    const selectedValue = e.target.value;
  
    setFormState((prevState) => {
      const currentPosition = Array.isArray(prevState.position)
        ? prevState.position
        : prevState.position
        ? [prevState.position]
        : []; 

        if (currentPosition.length >= 3) {
          alert("You can only select up to 3 positions.");
          return prevState;
        }
      if (selectedValue && !currentPosition.includes(selectedValue)) {
        return {
          ...prevState,
          position: [...currentPosition, selectedValue],
        };
      }
      return prevState;
    });
  };

  const handleDepartmentChange = (e) => {
    const selectedValue = e.target.value;
  
    setFormState((prevState) => {
      const currentDepartment = Array.isArray(prevState.department)
        ? prevState.department
        : prevState.department
        ? [prevState.department]
        : []; 

        if (currentDepartment.length >= 3) {
          alert("You can only select up to 3 departments.");
          return prevState;
        }

      if (selectedValue && !currentDepartment.includes(selectedValue)) {
        return {
          ...prevState,
          department: [...currentDepartment, selectedValue],
        };
      }
      return prevState;
    });
  };
  
  const handleRegionChange = (e) => {
    const selectedValue = e.target.value;
  
    setFormState((prevState) => {
      const currentWorkRegion = Array.isArray(prevState.workRegion)
        ? prevState.workRegion
        : prevState.workRegion
        ? [prevState.workRegion]
        : [];
      if (selectedValue && !currentWorkRegion.includes(selectedValue)) {
        return {
          ...prevState,
          workRegion: [...currentWorkRegion, selectedValue],
        };
      }
      return prevState; 
    });
  };
  
  

  const handleUnionChange = (e) => {
    const selectedValue = e.target.value;
  
    setFormState((prevState) => {
      const currentUnionType = Array.isArray(prevState.unionType)
        ? prevState.unionType
        : prevState.unionType
        ? [prevState.unionType]
        : [];

      if (selectedValue && !currentUnionType.includes(selectedValue)) {
        return {
          ...prevState,
          unionType: [...currentUnionType, selectedValue],
        };
      }
  
      return prevState;
    });
  };

const handleChange = (e) => {
    const { name, value } = e.target;
  
if (name === 'unionType') {
      setFormState((prevState) => {
        const updatedUnionType = prevState.unionType.includes(value)
          ? prevState.unionType
          : [...prevState.unionType, value];
        return {
          ...prevState,
          unionType: updatedUnionType,
        };
      });
     }
     else if (name === 'local') {
      setSelectedLocal(value);
      setFormState({
        ...formState,
        [name]: value,
      });
    } else if (name === 'union') {
      setSelectedUnion(value); 
      setFormState({
        ...formState,
        [name]: value, 
      });
      
    } else {
      setFormState({
        ...formState,
        [name]: value,
      });
    }
  };

  const handleResumeChange = (index, field, value) => {
    const updatedResumes = formState.resumes.map((resume, i) =>
      i === index ? { ...resume, [field]: value } : resume
    );
    setFormState({ ...formState, resumes: updatedResumes });
  };
  
  const addResumeField = () => {
    setFormState({
      ...formState,
      resumes: [...formState.resumes, { title: '', year: '', position: '' }],
    });
  };

  const handleRemovePositionFromTable = (positionToRemove) => {
    const updatedPositions = Array.isArray(formState.position)
      ? formState.position.filter((pos) => pos !== positionToRemove)
      : []; 
  
    setFormState((prevData) => ({
      ...prevData,
      position: updatedPositions,
    }));
  };


  const handleRemoveDepartmentFromTable = (departmentToRemove) => {
    const updatedDepartments = Array.isArray(formState.department)
      ? formState.department.filter((pos) => pos !== departmentToRemove)
      : []; 
  
    setFormState((prevData) => ({
      ...prevData,
      department: updatedDepartments,
    }));
  };

  const handleRemoveRegionFromTable = (workRegionToRemove) => {
    const updatedRegions = Array.isArray(formState.workRegion)
      ? formState.workRegion.filter((pos) => pos !== workRegionToRemove)
      : [];
  
    setFormState((prevData) => ({
      ...prevData,
      workRegion: updatedRegions,
    }));
  };

  const handleRemoveUnionTypeFromTable = (unionTypeToRemove) => {
    const updatedUnion = Array.isArray(formState.unionType)
      ? formState.unionType.filter((pos) => pos !== unionTypeToRemove)
      : [];
  
    setFormState((prevData) => ({
      ...prevData,
      unionType: updatedUnion,
    }));
  };

  const handleRemoveResumesFromTable = (indexToRemove) => {
    const updatedResumes = formState.resumes.filter((_, index) => index !== indexToRemove);
    setFormState((prevData) => ({
      ...prevData,
      resumes: updatedResumes,
    }));
  };

  const fileInputRefProfile = useRef(null);
  
  const handleRemoveImage = (index) => {
    const updatedProfileI = formState.profileI.filter((_, i) => i !== index);
    setProfilePreviews((prevPreviews) => prevPreviews.filter((_, i) => i !== index));
    setFormState((prevData) => ({
      ...prevData,
      profileI: updatedProfileI,
    }));
  };
  
  const handleAddImage = (event) => {
    const newFiles = Array.from(event.target.files).slice(0, 3);
  
    if (newFiles.length > 0) {
      setFormState((prevState) => {
        const updatedProfileI = [...prevState.profileI, ...newFiles].slice(0, 3);
        return {
          ...prevState,
          profileI: updatedProfileI,
        };
      });
  
      const newPreviews = newFiles.map((file) => URL.createObjectURL(file));
      setProfilePreviews((prevPreviews = []) => {
        const existingPreviews = prevPreviews.slice(0, formState.profileI.length);
        return [...existingPreviews, ...newPreviews].slice(0, 3);
      });
    }
  };
  
  const handleDeleteResume = () => {
    setFormState((prevState) => ({
      ...prevState,
      resumeP: null,
    }));
    setIsResumeDeleted(true);
  };
  
const fileInputRef = useRef(null);

const handleUploadResume = (event) => {
  const file = event.target.files[0];
  if (file) {
    setFormState({ ...formState, resumeP: file });
    setIsResumeDeleted(false);
  }
};


  const fileInputRefResidence = useRef(null); 

  const handleResidenceUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFormState({ ...formState, residence: file });
      setIsResidenceDeleted(false);  
    }
  };

  const handleDeleteResidence = () => {
    setFormState((prevState) => ({
      ...prevState,
      residence: null,
    }));
    setIsResidenceDeleted(true);
    console.log('Residence File deleted');
  };

  if (error) {
    return <div>Error: {error}</div>;
  }


  return (
    <form enctype="multipart/form-data">
      <>
          <>
         <div 
         style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        // marginTop: '12%',
        marginBottom: '12%',
        }}>
              <div className='top-card' style={{ width: '100%', maxWidth: '1000px' }}>
          <h1 className="justify-content-center"
          >Signup
          </h1>
              <Card 
           className=" p-4 card-body"
                    style={{
             marginTop: '5%',
             marginBottom: '5%',
             marginRight: 'auto',
             marginLeft: 'auto',
             maxWidth: '800px',
             width: '90%',
             height: 'auto',
             boxSizing: 'border-box',
             display: 'block', 
           }}
          >
        <CardText 
            style={{     
              display: 'inline-block',  
              overflow: 'hidden',
              boxSizing: 'border-box',
              justifyContent: 'center', 
            }}>
          Welcome to TRDirect — your go-to directory for Texas film 
          professionals to connect, collaborate, and find new opportunities.
          If you're a Texas resident working in film, sign up for free and 
          start building your network today!
        </CardText>
          </Card>
          <div style={{ justifyContent: 'center', }}>
          <h1 className="title-font justify-content-center"
          style={{
            marginTop: '2%',
            marginBottom: '1%',
            position: 'relative', zIndex: 2 
          }}>Name</h1>
           <div>
<h1 className='title-font justify-content-center'
  style={{
    marginTop: '2%',
  }}
>
  <input className="about-card-edit-name"
  style={{
  background: 'none',
  border: 'none',
  textAlign: 'center',
  caretColor: 'grey',
  width: `clamp(min(500px, 90vw), ${Math.max((formState.crewmember?.length || 1), 3)}ch, 90vw)`,
  boxSizing: 'border-box',
}}
    type="text"
    name="crewmember"
    value={formState.crewmember || ''}
    onChange={handleInputChange}
  />
</h1>
  <CardText style={{ textAlign: 'center', color: 'red', marginTop: '1%' }}>
    {nameError && nameError}
  </CardText>
</div>
          </div>     
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
             <div>
             {/* {formState && (
              <div className="flex col-12">
                <div>
                  <div style={{ display: 'flex', padding: 0, alignItems: 'center', justifyContent: 'center' }}>
                    {Array.isArray(formState.department) ? (
                      formState.department.map((department, index) => (
                        <div
                          key={index}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginRight: '15px',
                            position: 'relative',
                            marginTop: '5%',
                          }}
                        >
                          <h5 style={{ marginRight: '10px', fontSize: '18px' }}>{department}</h5>
                          <h3>
                          <Button
                          className="process-card-text hover-brighten-red"
                            style={{
                              backgroundColor: 'rgb(200, 0, 0)',
                              color: 'white',
                              border: 'none',
                              borderRadius: '50%',
                              marginBottom: "5%",
                              width: '25px',
                              height: '25px',
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '16px',
                              fontWeight: 'bold',
                              padding: 0,
                            }}
                            onClick={() => handleRemoveDepartmentFromTable(department)}
                          >
                            X
                          </Button>
                          </h3>
                        </div>
                      ))
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          marginRight: '15px',
                          position: 'relative',
                        }}
                      >
                        <h5 style={{ marginRight: '10px', fontSize: '18px' }}>{formState.department}</h5>
                        <h3>
                        <Button
                        className="process-card-text hover-brighten-red"
                          style={{
                            backgroundColor: 'rgb(200, 0, 0)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '50%',
                            width: '25px',
                            height: '25px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            padding: 0,
                          }}
                          onClick={() => handleRemoveDepartmentFromTable(formState.department)}
                        >
                          X
                        </Button>
                        </h3>
                      </div>
                    )}
                  </div>
                </div>

                <div>
                  <label htmlFor="department"></label>
                  <h3 style={{ justifyContent: 'center' }}>
                    <select
                      name="department"
                      value={selectedDepartment}
                      onChange={handleDepartmentChange}
                      id="department"
                      className="input-field"
                      style={{
                        padding: '5px',
                        background: 'none',
                        color: 'silver',
                      }}
                    >
                      <option value="">Add Department</option>
                      {departments.map((department) => (
                        <option key={department} value={department}>
                          {department}
                        </option>
                      ))}
                    </select>
                  </h3>
                  <CardText style={{ textAlign: 'center', color: 'red', marginTop: '1%' }}>
                  {departmentError && departmentError}
                  </CardText>
                </div>
              </div>
            )}                            */}
                <div style={{  display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <div className="flex col-12">
                        <div style={{ display: 'flex', padding: 0, alignItems: 'center', justifyContent: 'center',  }}>
                          {Array.isArray(formState.position) ? (
                            formState.position.map((position, index) => (
                              <h3
                                key={index}
                                style={{ 
                                  display: 'flex', 
                                  alignItems: 'center', 
                                  marginRight: '15px',
                                  position: 'relative',
                                  marginTop: '5%', }}
                               >
                                <h5 style={{ marginRight: '10px'}}>{position}</h5>
                                <Button
                                className="process-card-text hover-brighten-red"
                                  style={{
                                    backgroundColor: 'rgb(200, 0, 0)',
                                    color: 'white',
                                    border: '2px solid rgba(28, 26, 26, 0.9)',
                                    boxShadow: `
                                      0 2px 0 rgba(255, 255, 255, 0.12) inset,
                                      0 -1px 0 rgba(0, 0, 0, 0.45) inset,
                                      0 6px 12px rgba(0, 0, 0, 0.5),
                                      0 12px 24px rgba(0, 0, 0, 0.35)
                                    `,
                                    borderRadius: '50%',
                                    marginBottom: "5%",
                                    width: '25px',
                                    height: '25px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    padding: 0,
                                  }}
                                  onClick={() => handleRemovePositionFromTable(position)}
                                >
                                  X
                                </Button>
                              </h3>
                            ))
                          ) : (
                            <div>
                              <h5 style={{ marginRight: '10px',}}>{formState.position}</h5>
                              <h3>
                              <Button
                              className="process-card-text hover-brighten-red"
                              style={{
                                backgroundColor: 'rgb(200, 0, 0)',
                                color: 'white',
                                border: '2px solid rgba(28, 26, 26, 0.9)',
                                boxShadow: `
                                      0 2px 0 rgba(255, 255, 255, 0.12) inset,
                                      0 -1px 0 rgba(0, 0, 0, 0.45) inset,
                                      0 6px 12px rgba(0, 0, 0, 0.5),
                                      0 12px 24px rgba(0, 0, 0, 0.35)
                                    `,
                                borderRadius: '50%',
                                width: '25px',
                                height: '25px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '16px',
                                fontWeight: 'bold',
                                padding: 0,
                              }}
                                onClick={() => handleRemovePositionFromTable(formState.position)}
                              >
                                X
                              </Button>
                              </h3>
                            </div>
                          )}
                        </div>
                        <div>
                          <label htmlFor="position">   
                          </label>
                          <h3 style= {{
                        justifyContent: 'center', 
                      }}>
                        <div style={{ position: 'relative', display: 'inline-block' }}>
                          <select
                            name="position"
                            value={selectedPosition}
                            onChange={handlePositionChange}
                            id="position"
                            className="form-select about-card-edit"
                             style={{
                                    WebkitAppearance: 'none',
                                    MozAppearance: 'none',
                                    appearance: 'none',
                                    backgroundImage: 'none',
                                    backgroundColor: 'transparent',
                                    border: 'none',
                                    color: 'silver',
                                    padding: '5px 30px 5px 10px',
                                    width: '100%',
                                    fontSize: 'clamp(1.1rem, 2.5vw, 1rem)',
                                    textAlign: 'center',
                                  }}
                          >
                            <option value="">Add Position</option>
                            {positions.map((position) => (
                              <option key={position} value={position}>
                                {position}
                              </option>
                            ))}
                          </select>
                                 <span
                              style={{
                                position: 'absolute',
                                right: '8px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                pointerEvents: 'none',
                                color: 'silver',
                                fontSize: '0.8rem',
                              }}
                            >
                              ▼
                            </span>
                            </div>
                          </h3>
                          <CardText style={{ textAlign: 'center', color: 'red', marginTop: '1%' }}>
                          {positionError && positionError}
                          </CardText>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="justify-content-center">
                  <div className="justify-content-center" style={{ position: 'relative', marginBottom: '5%' }}>
                  {formState && Array.isArray(formState.profileI) && (
                    <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '10px' }}>
                      {formState.profileI.map((profileI, index) => (
                        <div key={index} style={{ marginTop: '2%', flex: '0 0 30%', position: 'relative' }}>
                          <img
                            src={
                              typeof profileI === "string"
                                ? profileI
                                : profilePreviews[index] || URL.createObjectURL(profileI)
                            }
                            alt={`crew image ${index + 1}`}
                            className="img-fluid"
                            style={{
                              width: '100%',
                              height: 'auto',
                              // maskImage: 'linear-gradient(to right, transparent, white 20%, white 80%, transparent)',
                              // WebkitMaskImage: 'linear-gradient(to right, transparent, white 20%, white 80%, transparent)',
                              // transition: 'mask-image 0.3s ease',
                              display: 'block',
                            }}
                          />
                          <h3>
                          <Button
                          className="process-card-text hover-brighten-red"
                            style={{
                              position: 'absolute',
                              top: '5px',
                              right: '5px',
                              backgroundColor: 'rgb(200, 0, 0)',
                              color: 'silver',
                              border: '1px solid rgba(28, 26, 26, 0.9)',
                              boxShadow: `
                                      0 2px 0 rgba(255, 255, 255, 0.12) inset,
                                      0 -1px 0 rgba(0, 0, 0, 0.45) inset,
                                      0 6px 12px rgba(0, 0, 0, 0.5),
                                      0 12px 24px rgba(0, 0, 0, 0.35)
                                    `,
                              borderRadius: '50%',
                              width: '25px',
                              height: '25px',
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '16px',
                              fontWeight: 'bold',
                              padding: 0,
                            }}
                            onClick={() => handleRemoveImage(index)}
                          >
                            X
                          </Button>
                          </h3>
                        </div>
                      ))}
                      {formState.profileI.length < 3 && (
                        <div 
                        style={{ flex: '0 0 30%', 
                        position: 'relative', 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center' }}>
                          <input
                            name="profileI"
                            type="file"
                            id="profileI"
                            accept="image/*"
                            onChange={handleFileSelect}
                            style={{ display: 'none' }}
                          />
                          <label htmlFor="profileI" style={{ cursor: 'pointer', margin: 0 }}>
                            <h3>
                              <Button
                                as="span"
                                className="process-card-text hover-brighten-green"
                                style={{
                                  padding: '10px 20px',
                                  marginTop: '10px',
                                  backgroundColor: 'rgb(0, 128, 0)',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '5px',
                                  cursor: 'pointer',
                                  textAlign: 'center',
                                  border: '2px solid rgba(28, 26, 26, 0.9)',
                                  boxShadow: `
                                    0 2px 0 rgba(255, 255, 255, 0.12) inset,
                                    0 -1px 0 rgba(0, 0, 0, 0.45) inset,
                                    0 6px 12px rgba(0, 0, 0, 0.5),
                                    0 12px 24px rgba(0, 0, 0, 0.35)
                                  `,
                                  borderRadius: '999px',
                                  padding: '0.4rem 1rem',
                                }}
                              >
                                <h5 style={{ margin: '1%' }}>+ Add Image</h5>
                              </Button>
                            </h3>
                          </label>
                          <CardText style={{ textAlign: 'center', color: 'red', marginTop: '1%' }}>
                            {profileIError && profileIError}
                          </CardText>
                        </div>
                      )}
                    </div>
                  )}
                  </div>
                  <ImageCropModal
                    show={cropModalOpen}
                    imageSrc={rawImageSrc}
                    onCancel={() => setCropModalOpen(false)}
                    onCropComplete={handleCropComplete}
                  />
                </div>
                
              <div>
              <Card
              className="p-4 card-body"
               style={{
                      marginRight: '7%',
                      marginLeft: '7%',
                      marginBottom: '5%',
                      width: 'auto',
                      height: 'auto',
                      display: 'block',
                      boxSizing: 'border-box',
                    }}
            >

          <div className="row gy-4 justify-content-center">
            <div className="col-12 col-md-6 col-lg-6 d-flex flex-column"> 
            <h5 className="mb-2" style={{ justifyContent: 'center' }}>Location</h5>          
            <div style={{ position: 'relative', width: '100%' }}>
              <select
                className="form-control about-card-edit"
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'silver',
                  width: '100%',
                  fontSize: '1.2rem',
                  textAlign: 'center',
                  textAlignLast: 'center'
                }}
                name="location"
                value={formState.location || ''}
                onChange={handleInputChange}
              >
                <option value="" disabled>Select a city</option>
                {texasCities.map((city) => (
                  <option key={city} value={city}>{city}</option>
                ))}
              </select>
              <span
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  pointerEvents: 'none',
                  color: 'silver',
                  fontSize: '0.8rem',
                }}
              >
                ▼
              </span>
              </div>
              <CardText>
                {locationError && locationError}
              </CardText>
              </div>

                {/* Work Region */}
                <div className="col-12 col-md-6 col-lg-6 d-flex flex-column">
                  <h5 className="mb-2" style={{justifyContent: 'center' }}>Work Region(s)</h5>
                  <div style={{ position: 'relative', width: '100%' }}>
                  <select
                    name="workRegion"
                    value={selectedRegion}
                    onChange={handleRegionChange}
                    className="form-select mb-2 about-card-edit"
                    style={{
                      WebkitAppearance: 'none',
                      MozAppearance: 'none',
                      appearance: 'none',
                      backgroundImage: 'none',
                      backgroundColor: 'transparent',
                      border: 'none',
                      color: 'silver',
                      padding: '5px 30px 5px 10px',
                      width: '100%',
                      fontSize: 'clamp(1.1rem, 2.5vw, 1rem)'
                    }}
                  >
                    <option value=""
                    style={{
                      textAlign: 'center',
                    }}
                    >Add Region</option>
                    {workRegion.map((region) => (
                      <option key={region} value={region}>
                        {region}
                      </option>
                    ))}
                  </select>
                  <span
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  pointerEvents: 'none',
                  color: 'silver',
                  fontSize: '0.8rem',
                }}
              >
                ▼
              </span>
              </div>
              <CardText>
                {workRegionError && workRegionError}
              </CardText>
                  <ListGroup className="w-100 ">
                    {(Array.isArray(formState.workRegion) ? formState.workRegion : [formState.workRegion]).map((region, index) => (
                      <ListGroupItem 
                      className="position-relative" 
                      key={index} 
                      style={{
                        background: 'none',
                        color: 'silver',
                        fontSize: '1rem',
                        border: 'none',
                        textAlign: 'center'
                      }}>
                        {region}
                        <h3>
                        <Button
                        className="process-card-text hover-brighten-red"
                          size="sm"
                          style={{
                                position: 'absolute',
                                top: '5px',
                                right: '5px',
                                backgroundColor: 'rgb(200, 0, 0)',
                                color: 'white',
                                border: '2px solid rgba(28, 26, 26, 0.9)',
                                boxShadow: `
                                      0 2px 0 rgba(255, 255, 255, 0.12) inset,
                                      0 -1px 0 rgba(0, 0, 0, 0.45) inset,
                                      0 6px 12px rgba(0, 0, 0, 0.5),
                                      0 12px 24px rgba(0, 0, 0, 0.35)
                                    `,
                                borderRadius: '50%',
                                width: '25px',
                                height: '25px',
                                 display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                padding: 0,
                              }}
                          onClick={() => handleRemoveRegionFromTable(region)}
                        >
                          X
                        </Button>
                        </h3>
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                </div>
                <div className="col-12 col-md-6 col-lg-6 d-flex flex-column">
                  <h5 className="mb-2" style={{justifyContent: 'center' }}>Will Work as a Local</h5>
                  <div style={{ position: 'relative', width: '100%' }}>
                  <select
                    name="local"
                    value={formState.local}
                    onChange={handleChange}
                    className="form-select about-card-edit"
                    style={{
                      WebkitAppearance: 'none',
                      MozAppearance: 'none',
                      appearance: 'none',
                      backgroundImage: 'none',
                      backgroundColor: 'transparent',
                      border: 'none',
                      color: 'silver',
                      padding: '5px 30px 5px 10px',
                      width: '100%',
                      fontSize: 'clamp(1.1rem, 2.5vw, 1rem)'
                    }}
                  >
                    {!selectedLocal && (
                      <option value="" disabled
                      style={{
                        textAlign: 'center',
                      }}
                      >Select Option</option>
                    )}
                    <option value="Yes"
                    style={{
                      textAlign: 'center',
                    }}
                    >Yes</option>
                    <option value="No"
                    style={{
                      textAlign: 'center',
                    }}
                    >No</option>
                  </select>
                  <span
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    pointerEvents: 'none',
                    color: 'silver',
                    fontSize: '0.8rem',
                  }}
                >
                ▼
              </span>
              </div>
              <CardText>
                {localError && localError}
              </CardText>
                </div>
                <div className="col-12 col-md-6 col-lg-6 d-flex flex-column">
                  <h5 className="mb-2" style={{justifyContent: 'center' }}>Union / Guild Affiliations</h5>
                  <div style={{ position: 'relative', width: '100%' }}>
                  <select
                    name="unionType"
                    value={selectedUnionType}
                    onChange={handleUnionChange}
                    className="form-select mb-2 about-card-edit"
                    style={{
                      WebkitAppearance: 'none',
                      MozAppearance: 'none',
                      appearance: 'none',
                      backgroundImage: 'none',
                      backgroundColor: 'transparent',
                      border: 'none',
                      color: 'silver',
                      padding: '5px 30px 5px 10px',
                      width: '100%',
                      fontSize: 'clamp(1.1rem, 2.5vw, 1rem)'
                    }}
                  >
                    <option value=""
                    style={{
                      textAlign: 'center',
                    }}
                    >Add Union</option>
                    {unionType.map((union) => (
                      <option key={union} value={union}>
                        {union}
                      </option>
                    ))}
                  </select>
              <span
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  pointerEvents: 'none',
                  color: 'silver',
                  fontSize: '0.8rem',
                }}
              >
                ▼
              </span>
            </div>
            <CardText>
              {unionTypeError && unionTypeError}
            </CardText>
              <ListGroup className="w-100 mt-2">
                {(Array.isArray(formState.unionType) ? formState.unionType : [formState.unionType]).map((union, index) => (
                  <ListGroupItem key={index} 
                  className="position-relative"
                  style={{
                    background: 'none',
                    color: 'silver',
                    fontSize: '1rem',
                    border: 'none',
                    textAlign: 'center', 
                  }}>
                    {union}
                    <h3>
                    <Button
                    className="process-card-text hover-brighten-red"
                      size="sm"
                       style={{
                                position: 'absolute',
                                top: '5px',
                                right: '5px',
                                backgroundColor: 'rgb(200, 0, 0)',
                                color: 'white',
                                border: '2px solid rgba(28, 26, 26, 0.9)',
                                boxShadow: `
                                      0 2px 0 rgba(255, 255, 255, 0.12) inset,
                                      0 -1px 0 rgba(0, 0, 0, 0.45) inset,
                                      0 6px 12px rgba(0, 0, 0, 0.5),
                                      0 12px 24px rgba(0, 0, 0, 0.35)
                                    `,
                                borderRadius: '50%',
                                width: '25px',
                                height: '25px',
                                 display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                padding: 0,
                              }}
                      onClick={() => handleRemoveUnionTypeFromTable(union)}
                    >
                      X
                    </Button>
                    </h3>
                  </ListGroupItem>
                ))}
              </ListGroup>
            </div>
          </div>
        </Card>
        </div>
              <Card
                 className="p-4 card-body"
                  style={{
                      marginRight: '7%',
                      marginLeft: '7%',
                      marginBottom: '5%',
                      width: 'auto',
                      height: 'auto',
                      boxSizing: 'border-box',
                      display: 'block',
                    }}
                >
                <h5 className="justify-content-center">credits</h5>
                      {formState &&
                        Array.isArray(formState.resumes) &&
                        formState.resumes.map((resume, index) => (
                        <div key={index}>
                            <Card>  
                              <>
                              <div className="row gy-4 justify-content-center" style={{ margin: '2%'}}>
                                <div className="col-10 col-md-4 col-lg-4 d-flex flex-column justify-content-center">           
                                    <h5 className="mb-2" style={{justifyContent: 'center' }}>Position</h5> 
                                      <div style={{ position: 'relative', width: '100%', }}>
                                      <input
                                        className="form-control about-card-edit"
                                        style={{
                                          background: 'none',
                                          border: 'none',
                                          height: '100%',
                                          width: '100%',
                                          textAlign: 'center',
                                          color: 'silver',
                                          caretColor: 'grey',
                                          fontSize: '1.2rem',
                                        }}
                                        type="text"
                                        name={`position-${index}`}
                                        value={formState.resumes[index]?.position || ''}
                                        onChange={(e) =>
                                          handleResumeChange(index, 'position', e.target.value)
                                        }
                              />
                            </div>
                          </div>

                        <div className="col-10 col-md-4 col-lg-4 d-flex flex-column">
                          <h5 className="mb-2" style={{justifyContent: 'center' }}>Show</h5>
                            <div style={{ position: 'relative', width: '100%' }}>
                              <input
                                className="form-control about-card-edit"
                                style={{
                                  background: 'none',
                                  border: 'none',
                                  height: '100%',
                                  width: '100%',
                                  textAlign: 'center',
                                  color: 'silver',
                                  caretColor: 'grey',
                                  fontSize: '1.2rem',
                                }}
                                type="text"
                                name={`title-${index}`}
                                value={formState.resumes[index]?.title || ''}
                                onChange={(e) =>
                                  handleResumeChange(index, 'title', e.target.value)
                                }
                              />
                            </div>
                          </div>

                          <div className="col-10 col-md-4 col-lg-4 d-flex flex-column">
                          <h5 className="mb-2" style={{justifyContent: 'center' }}>Year</h5>
                            <div style={{ position: 'relative', width: '100%' }}>
                              <input
                                className="form-control about-card-edit"
                                style={{
                                  background: 'none',
                                  border: 'none',
                                  height: '100%',
                                  width: '100%',
                                  textAlign: 'center',
                                  color: 'silver',
                                  caretColor: 'grey',
                                  fontSize: '1.2rem',
                                }}
                                type="text"
                                name={`year-${index}`}
                                value={formState.resumes[index]?.year || ''}
                                onChange={(e) =>
                                  handleResumeChange(index, 'year', e.target.value)
                                }
                              />
                            </div>
                          </div>
                      </div>
  
                      <div className="justify-content-center">
                        <h3>
                        <Button className="process-card-text hover-brighten-red"
                                style={{
                                  position: 'absolute',
                                  top: '35px',
                                  right: '3px',
                                  backgroundColor: 'rgb(200, 0, 0)',
                                  color: 'white',
                                  border: '2px solid rgba(28, 26, 26, 0.9)',
                                  boxShadow: `
                                      0 2px 0 rgba(255, 255, 255, 0.12) inset,
                                      0 -1px 0 rgba(0, 0, 0, 0.45) inset,
                                      0 6px 12px rgba(0, 0, 0, 0.5),
                                      0 12px 24px rgba(0, 0, 0, 0.35)
                                    `,
                                  borderRadius: '50%',
                                  width: '25px',
                                  height: '25px',
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontSize: '16px', 
                                  fontWeight: 'bold',
                                  padding: 0, 
                                  }}
                              onClick={() => handleRemoveResumesFromTable(index)}
                            >
                              X
                          </Button>

                        </h3>
                      </div>
                    </>
                    
                </Card>
                {index < formState.resumes.length - 1 && (
                  <hr 
                  style={{
                    borderTop: '3px solid #ccc',
                    boxShadow: '0 0 5px #ffcc00'
                  }}
                  />
                )}
              </div>
              ))}
                 <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2%' }}>
                  <Button
                    className="process-card-text hover-brighten-green"
                    variant="link"
                    onClick={addResumeField}
                    style={{
                      backgroundColor: 'rgb(0, 128, 0)',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textDecoration: 'none',
                      border: '2px solid rgba(28, 26, 26, 0.9)',
                      boxShadow: `
                          0 2px 0 rgba(255, 255, 255, 0.12) inset,
                          0 -1px 0 rgba(0, 0, 0, 0.45) inset,
                          0 6px 12px rgba(0, 0, 0, 0.5),
                          0 12px 24px rgba(0, 0, 0, 0.35)
                        `,
                      borderRadius: '999px',
                      padding: '0.4rem 1rem',
                      
                    
                    }}
                  >
                    <h5 style={{ margin: '1%', color: 'white' }}>Add</h5>
                  </Button>
                </div>
               </Card>
             
                <Card
                  className="card-body"
                  style={{
                    marginTop: '5%',
                    marginBottom: '5%',
                    marginRight: '25%',
                    marginLeft: '30%',
                    width: '40%',       
                    display: 'block',  
                    overflow: 'hidden',
                    boxSizing: 'border-box', 
                  }}
                >
                  <div className="justify-content-center" style={{ position: 'relative', }}>
                      <div style={{ marginTop: '10px' }}>
                    {(!formState || !formState.resumeP || isResumeDeleted) && (
                      <div style={{ marginTop: '10px' }}>
                        <Button
                        className="process-card-text hover-brighten-green"
                          onClick={() => fileInputRef.current.click()}
                          style={{
                            display: 'block',
                            height: '40%',
                            width: 'auto',
                            margin: '5px auto',
                            fontSize: '2.5vmin',
                            backgroundColor: 'rgb(0, 128, 0)',
                            color: '#fff',
                            border: '2px solid rgba(28, 26, 26, 0.9)',
                            boxShadow: `
                                0 2px 0 rgba(255, 255, 255, 0.12) inset,
                                0 -1px 0 rgba(0, 0, 0, 0.45) inset,
                                0 6px 12px rgba(0, 0, 0, 0.5),
                                0 12px 24px rgba(0, 0, 0, 0.35)
                              `,
                            borderRadius: '999px',
                            padding: '0.4rem 1rem',
                            cursor: 'pointer',
                            textAlign: 'center',
                          }}
                        >
                          <input
                            ref={fileInputRef}
                            type="file"
                            accept=".pdf,.doc,.docx"
                            style={{ display: 'none' }}
                            onChange={handleUploadResume}
                          />
                          <h5 style={{ margin: '1%' }}>Upload Resume</h5>
                        </Button>
                      </div>
                    )}
                        
                        {formState && formState.resumeP && !isResumeDeleted && (
                            <Button
                            className="process-card-text hover-brighten-red"
                              onClick={handleDeleteResume}
                              style={{
                                display: 'block',
                                height: '40%',
                                width: 'auto',
                                margin: '5px auto',
                                fontSize: '2.5vmin',
                                backgroundColor: 'rgb(200, 0, 0)',
                                color: '#fff',
                                border: '2px solid rgba(28, 26, 26, 0.9)',
                                boxShadow: `
                                    0 2px 0 rgba(255, 255, 255, 0.12) inset,
                                    0 -1px 0 rgba(0, 0, 0, 0.45) inset,
                                    0 6px 12px rgba(0, 0, 0, 0.5),
                                    0 12px 24px rgba(0, 0, 0, 0.35)
                                  `,
                                borderRadius: '999px',
                                padding: '0.4rem 1rem',
                                cursor: 'pointer',
                                textAlign: 'center',
                                
                              }}
                            >
                              <h5 style={{ margin: '1%' }}>Delete Resume</h5>
                            </Button>
                          )}
                      </div>
                  </div>
                </Card>
                
                <Card 
                  className=" card-body "
                  style={{
                    display: 'block',
                    marginRight: '10%',
                    marginLeft: '10%',
                    marginBottom: '5%',
                    width: 'auto',
                    height: 'auto',
                    boxSizing: 'border-box',
                  }}
                  >
                <div className="row gy-4">
                 <div className="col-12 col-md-6 col-lg-6 d-flex flex-column align-items-start">
                    <>
                      <h5 className="mb-2" style={{ fontSize: '1.25rem' }}>Email</h5>
                      <input
                        className="form-control about-card-edit"
                        style={{
                          background: 'none',
                          border: 'none',
                          color: 'silver',
                          caretColor: 'grey',
                          width: '100%',
                          fontSize: '1.2rem',
                        }}
                        type="text"
                        name="email"
                        value={formState.email || ''}
                        onChange={handleInputChange}
                      />
                      <CardText>
                        {emailError && emailError}
                      </CardText>
                    </>
                </div> 

                <div className="col-12 col-md-6 col-lg-6 d-flex flex-column align-items-start">
                    <>
                    <h5 className="mb-2" style={{ fontSize: '1.25rem' }}>iMDB Link</h5>
                      <input
                         className="form-control about-card-edit"
                         style={{
                           background: 'none',
                           border: 'none',
                           color: 'silver',
                           caretColor: 'grey',
                           width: '100%',
                           fontSize: '1.2rem',
                         }}
                        type="text"
                        name="iMDB"
                        value={formState.iMDB || ''}
                        onChange={handleInputChange}
                      />
                    </>
                 </div>
              
                  <div className="col-12 col-md-6 col-lg-6 d-flex flex-column align-items-start">
                    <>
                      <h5 className="mb-2" style={{ fontSize: '1.25rem' }}>Password</h5>
                      <input
                         className="form-control about-card-edit"
                         style={{
                           background: 'none',
                           border: 'none',
                           color: 'silver',
                           caretColor: 'grey',
                           width: '100%',
                           fontSize: '1.2rem',
                         }}
                        type="text" 
                        name="password"
                        value={isTyping ? formState.password : ''} 
                        onChange={(e) => {
                          setIsTyping(true);
                          handleInputChange(e);
                        }}
                      />
                      <CardText>
                        {passwordError && passwordError}
                      </CardText>
                    </>
                    </div> 
              <div className='justify-content-center align-items-center'>
                <div className="flex">
                 <h5 className="mb-2 justify-content-center" >Proof of Texas Residency</h5>
                  <CardText
                  style={{     
                    display: 'inline-block',  
                    overflow: 'hidden',
                    boxSizing: 'border-box',
                    justifyContent: 'center', 
                  }}
                  >
                    To be listed on TRDirect, you must be a Texas resident and provide supporting documentation 
                    for verification purposes. This information will remain confidential and will not be publicly 
                    available. Please avoid submitting sensitive data, such as Social Security Numbers or financial information.
                  </CardText>                    
                    <div style={{ marginTop: '8%' }}>
                     {formState && formState.residence && !isResidenceDeleted && (
                      <Button
                      className="process-card-text hover-brighten-red"
                        onClick={handleDeleteResidence}
                         style={{
                          display: 'block',
                          height: '40%',
                          width: 'auto',
                          margin: '5px auto',
                          fontSize: '2.5vmin',
                          backgroundColor: 'rgb(200, 0, 0)',
                          color: '#fff',
                          border: '2px solid rgba(28, 26, 26, 0.9)',
                          boxShadow: `
                              0 2px 0 rgba(255, 255, 255, 0.12) inset,
                              0 -1px 0 rgba(0, 0, 0, 0.45) inset,
                              0 6px 12px rgba(0, 0, 0, 0.5),
                              0 12px 24px rgba(0, 0, 0, 0.35)
                            `,
                          borderRadius: '999px',
                          padding: '0.4rem 1rem',
                          cursor: 'pointer',
                          textAlign: 'center',
                          }}
                           >
                          <h5 style={{ margin: '1%' }}>Replace Residency Doc</h5>
                       </Button>
                        )}                               
                        {(!formState || !formState.residence || isResidenceDeleted) && (
                         <div style={{ marginTop: '10px' }}>
                          <Button
                          className="process-card-text hover-brighten-green"
                           onClick={() => fileInputRefResidence.current.click()} 
                            style={{
                            display: 'block',
                            height: '40%',
                            width: 'auto',
                            margin: '5px auto',
                            fontSize: '2.5vmin',
                            backgroundColor: 'rgb(0, 128, 0)',
                            color: '#fff',
                            border: '2px solid rgba(28, 26, 26, 0.9)',
                            boxShadow: `
                                0 2px 0 rgba(255, 255, 255, 0.12) inset,
                                0 -1px 0 rgba(0, 0, 0, 0.45) inset,
                                0 6px 12px rgba(0, 0, 0, 0.5),
                                0 12px 24px rgba(0, 0, 0, 0.35)
                              `,
                            borderRadius: '999px',
                            padding: '0.4rem 1rem',
                            cursor: 'pointer',
                            textAlign: 'center',
                            }}
                             >
                            <input
                             ref={fileInputRefResidence}
                             type="file"
                             accept=".pdf,.doc,.docx"
                             style={{ display: 'none' }}
                             onChange={handleResidenceUpload}
                              />
                            <h5 style={{ margin: '1%' }}>Upload Residency Doc</h5>
                          </Button>
                    </div>
                    )}
                  </div>
                  <CardText style={{ textAlign: 'center', color: 'red', marginTop: '1%' }}>
                    {residenceError && residenceError}
                  </CardText>
                
                </div>          
                  </div>
                </div>
                </Card>

                 <div style={{ display: 'flex', justifyContent: 'center', marginTop: '7%' }}>
                    <Button
                      className="process-card-text hover-brighten"
                      variant="link"
                       onClick={handleFormSubmit}
                      style={{
                        backgroundColor: 'rgb(67, 66, 66)',
                        border: '2px solid rgba(28, 26, 26, 0.9)',
                        boxShadow: `
                          0 2px 0 rgba(255, 255, 255, 0.12) inset,
                          0 -1px 0 rgba(0, 0, 0, 0.45) inset,
                          0 6px 12px rgba(0, 0, 0, 0.5),
                          0 12px 24px rgba(0, 0, 0, 0.35)
                        `,
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textDecoration: 'none',
                        borderRadius: '999px',
                        padding: '0.4rem 1rem',
                      }}
                    >
                      <h5 style={{ margin: '1%' }}>Submit</h5>
                    </Button>
                  </div>
                
              </div>
            </div>
          </>
       </>

  </form>
 );

}

export default SignUp;